import { createContext } from 'react';
import { Account } from '../../types';

export interface AccountContextType {
	account: Account | null;
	questionCount: number;
}

export default createContext<AccountContextType | null>(null);
